import Axios from 'axios'
let loadingInstance = null
// const { protocol, hostname } = window.location
// const baseHref = `${protocol}//${hostname}/`
Axios.defaults.baseURL = 'http://img.chinaaiei.com:8000'
console.log(Axios.defaults.baseURL)
Axios.interceptors.request.use(
  config => {
    // 是否开启loading
    return config
  },
  () => {
    return Promise.reject('请检查本地网络状况')
  }
)

Axios.interceptors.response.use(
  ({
    status,
    data
  }) => {
    console.log(status)
    if (status === 200) {
      if (data.code === 200 || data.code === '200') {
        return {
          success: true,
          code: 200,
          message: data.message,
          data: data.data
        }
      }
    } else {
      return Promise.reject(new Error('服务器出错，请稍后再试'))
    }
  },
  () => {
    return Promise.reject('服务器正在发呆，请稍后再试')
  }
)

export const fetch = (url, payload) => {
  return Axios.get(url, {
      params: payload
    })
    .then(res => {
      return Promise.resolve(res)
    })
    .catch(err => {
      if (loadingInstance) {
        loadingInstance.close()
        loadingInstance = null
      }
      return Promise.reject(err)
    })
}

export const post = (url, payload) => {
  return Axios.post(url, payload)
    .then(res => {
      return Promise.resolve(res)
    })
    .catch(err => {
      if (loadingInstance) {
        loadingInstance.close()
        loadingInstance = null
      }
      return Promise.reject(err)
    })
}

export const del = (url, payload) => {
  return Axios.delete(url, {
      params: payload
    })
    .then(res => {
      return Promise.resolve(res)
    })
    .catch(err => {
      if (loadingInstance) {
        loadingInstance.close()
        loadingInstance = null
      }
      return Promise.reject(err)
    })
}
// export default Axios
